module.exports = __webpack_public_path__ + "static/img/default.0ad1c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.png
// module id = jY2U
// module chunks = 12